import React from "react";
import { Box, Container } from "@mui/material";
import { motion } from "framer-motion";

const BlogContent = ({ children }) => {
  return (
    <Container
      component={motion.article}
      maxWidth={false}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.4 }}
      sx={{ 
        maxWidth: 860, 
        mx: "auto", 
        px: { xs: 2, sm: 3, md: 4 }, 
        py: { xs: 6, md: 8 }, 
        fontFamily: "Segoe UI regular",
        fontSize: { xs: 16, md: 18 },
      }}
    >
      <Box>{children}</Box>
    </Container>
  );
};

export default BlogContent;
